<div class="inner-card-group" [ngClass]="{transparent: isTransparent, 'd-block': isFullWidth}">
  <ng-content></ng-content>
</div>
